import { EmailTemplateFolder } from '../models';
import { ModelResource } from './resource';

export class EmailTemplateFolders extends ModelResource<EmailTemplateFolder> {
  model = EmailTemplateFolder;

  resourcePath = 'v1/email-template-folders';
}
